import PropTypes from 'prop-types';
import { useTheme } from '@emotion/react';
import { useSearchParams } from 'react-router-dom';

import { Tab, Tabs, alpha } from '@mui/material';

// ----------------------------------------------------------------------

export const AUTOMATION_SORT = {
  AUTOMATION: 'AUTOMATION',
  FINDINGS: 'FINDINGS',
  RULE: 'RULE', // rules
};

export default function AutomationSort({ sort, setSort, dataList }) {
  const theme = useTheme();

  // On mount or URL change: read sort from URL and update setSort

  const TABS = [
    {
      value: AUTOMATION_SORT.AUTOMATION,
      label: 'Automation',
      count: dataList || 0,
    },
    {
      value: AUTOMATION_SORT.FINDINGS,
      label: 'Findings',
      count: dataList || 0,
    },
    {
      value: AUTOMATION_SORT.RULE,
      label: 'Rules',
      count: dataList || 0,
    },
  ];

  // eslint-disable-next-line no-unused-vars
  const [_, setSearchParams] = useSearchParams();

  return (
    <Tabs
      value={sort}
      onChange={(e, newValue) => {
        if (newValue !== sort) {
          setSort(newValue);
          setSearchParams({ sort: newValue });
        }
      }}
      sx={{
        px: 2.5,
        boxShadow: `inset 0 -2px 0 0 ${alpha(theme.palette.grey[500], 0.08)}`,
        maxWidth: 'fit-content',
      }}
    >
      {TABS?.map((tab) => (
        <Tab key={tab.value} value={tab.value} label={tab.label} iconPosition="end" />
      ))}
    </Tabs>
  );
}

AutomationSort.propTypes = {
  setSort: PropTypes.func,
  sort: PropTypes.string,
  dataList: PropTypes.any,
};
